module.exports = __webpack_public_path__ + "static/media/testimony.bc560060.png";